import React from 'react';

type BrandNameProps = {
  className?: string;
  variant?: 'light' | 'dark' | 'auto' | 'white' | 'onGreen';
  style?: React.CSSProperties;
};

export default function BrandName({ className = '', variant = 'auto', style }: BrandNameProps) {
  // Determine text colors based on variant
  let careColor = '#214895'; // exact brand blue
  let ascendiumColor = '#74BC28'; // exact brand green

  if (variant === 'white') {
    careColor = '#ffffff';
    ascendiumColor = '#ffffff';
  } else if (variant === 'dark') {
    careColor = '#ffffff';
    ascendiumColor = '#74BC28';
  } else if (variant === 'light') {
    careColor = '#214895';
    ascendiumColor = '#74BC28';
  } else if (variant === 'onGreen') {
    careColor = '#214895';
    ascendiumColor = '#ffffff';
  } else {
    // variant === 'auto' fallback
    careColor = '#214895';
    ascendiumColor = '#74BC28';
  }

  return (
    <span
      className={`brand-name-inline ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        fontFamily: "'Poppins', sans-serif",
        fontSize: 'inherit',
        lineHeight: 1,
        letterSpacing: '0.8px',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span
        className="brand-care"
        style={{
          fontFamily: "'Poppins', sans-serif",
          color: careColor,
          fontWeight: 400,
          fontSize: 'inherit',
          lineHeight: 1,
          letterSpacing: '0.8px',
          textTransform: 'uppercase',
        }}
      >
        CARE
      </span>
      <span
        className="brand-ascendium"
        style={{
          fontFamily: "'Poppins', sans-serif",
          color: ascendiumColor,
          fontWeight: 600,
          fontSize: 'inherit',
          lineHeight: 1,
          letterSpacing: '0.8px',
          textTransform: 'uppercase',
        }}
      >
        ASCENDIUM
      </span>
    </span>
  );
}
